import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { IBuildingFilter } from "../models/filters/buildingFilter";
import { IBuildingForm } from "../models/forms/buildingForm";
import { IBuildingPDTO } from "../models/dtos/buildingPDTO";

// Service for Building operations
export default class BuildingService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/Building";

    protected static override  getUrlFilter<F extends IBuildingFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;

            if(filter.isHorizontal != undefined)
                url += `&IsHorizontal=${filter.isHorizontal}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IBuildingForm):IBuildingPDTO {
        const dto = super.toDTO(obj) as IBuildingPDTO;
        return dto;
    }
}